import { Component, Input } from '@angular/core';

@Component({ standalone: false,
  selector: 'app-design-loader',
  templateUrl: './design-loader.component.html',
  styleUrls: ['./design-loader.component.scss']
})
export class DesignLoaderComponent {
  @Input() progress = 0;
  @Input() fromEvent = '';


  constructor() { }

}
